import type { ChatbotContextData } from '../../types';
import { gigaOrderSchema, gigaUserSchema } from './schemas';
import type { GigaInitializationValues } from './types';

const GIGA_MAX_ORDERS = 10;

const pickOrder = (context: ChatbotContextData, index: number) =>
  Object.fromEntries(
    Object.keys(gigaOrderSchema.shape).map((key) => [key, context[`${key}${index}`]]),
  );

/**
 * Maps our flat chatbot context to Giga's `initialization_values` schema: the user fields, the
 * browser's IANA `timezone` and the order fields numbered per shipment, 1 to 10. Every field is
 * always sent, parsed by its schema; keys outside the schema are dropped.
 */
export const mapContextToGiga = (context: ChatbotContextData): GigaInitializationValues => {
  const { timeZone } = Intl.DateTimeFormat().resolvedOptions();
  const values: ChatbotContextData = gigaUserSchema.parse({ ...context, timezone: timeZone });

  for (let index = 1; index <= GIGA_MAX_ORDERS; index++) {
    const order = gigaOrderSchema.parse(pickOrder(context, index));
    Object.entries(order).forEach(([key, value]) => {
      values[`${key}${index}`] = value;
    });
  }

  return values as GigaInitializationValues;
};
